/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-19T03:18:25.315Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeQuery', // 42
	'PageTreeQueryWithSpaceKeyQuery', // 43
	'PermissionCheckAddCommentQuery', // 44
	'PersistentInviteEligibleQuery', // 45
	'PersonalizedTemplatesV2AllTemplatesQuery', // 46
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 47
	'Preferences', // 48
	'PremiumTrialEotQuery', // 49
	'ReactionsContentQuery', // 50
	'RecentlyUpdatedMacroQuery', // 51
	'RendererContentStateQuery', // 52
	'RestrictedPageWithCanViewQuery', // 53
	'ScreenQuery', // 54
	'SiteInformationQuery', // 55
	'SmartCreateFeedbackBannerQuery', // 56
	'SmartCreatePageEditorDataWrapperComponentQuery', // 57
	'SpaceNavigationQuery', // 58
	'SpaceOverviewIdQuery', // 59
	'SpaceOverviewQuery', // 60
	'SpaceQuery', // 61
	'SpaceRestrictionCheckQuery', // 62
	'ThemeQuery', // 63
	'TopNavigationQuery', // 64
	'UserSettingsQuery', // 65
	'ViewSpaceExternalCollaboratorsDialogQuery', // 66
	'WebItemLocationQuery_page.metadata.banner', // 67
	'WebItemLocationQuery_system.content.byline', // 68
	'WebItemLocationQuery_system.header_left', // 69
	'WebItemLocationQuery_system.header_left_system.user', // 70
	'WebPanelLocationQuery_atl.footer', // 71
	'WebPanelLocationQuery_atl.general', // 72
	'WebPanelLocationQuery_atl.general_atl.footer', // 73
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 74
	'WebStorageCategories', // 75
	'WelcomeMessagesQuery', // 76
	'WhiteboardUnifiedQuery', // 77
	'contentAppearanceQuery', // 78
	'contentSmartLinksORS', // 79
	'fetchMentionsProviderDataQuery', // 80
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 81
	'graphqlHelpersFetchMediaTokenQuery', // 82
	'multiMacroQueryWithAppKeyQuery', // 83
	'onboardingStateGetOnboardingStateQuery', // 84
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 85
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 86
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 87
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 88
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 89
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 90
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages', // 91
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2', // 92
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 93
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_66', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 101
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 102
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_153', // 103
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_154', // 104
	'pageButtons', // 105
	'preloadAutohighlightsQuery', // 106
	'preloadContentSmartLinksQuery', // 107
	'preloadCreateSpaceQuery', // 108
	'preloadEditButtonWithSpaceKeyQuery', // 109
	'preloadEditorNodeDataProvidersDataQuery', // 110
	'preloadLegacyBridgeQuery', // 111
	'preloadOperationsQuery', // 112
	'preloadPageStatusQueryDataQuery', // 113
	'preloadPersonalSpaceDetailsQuery', // 114
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 115
	'preloadSpaceBlogCountQuery', // 116
	'preloadTemplatesCollectionEligibleQuery', // 117
	'requireSuperBatchFrontendResourceRenderQuery', // 118
	'rightPanel', // 119
	'searchCombinedConfig', // 120
	'searchResults', // 121
	'sidenavSmartLinksORS', // 122
	'useAnalyticsByLineQuery', // 123
	'useAudioContentQuery', // 124
	'useBlogPostsQueryQuery', // 125
	'useConfluenceStandardToPremiumExperimentQuery', // 126
	'useContentClassificationContentDataClassificationQuery', // 127
	'useEditorContentModeValueQuery', // 128
	'useEmojiEverSetPropertyQuery', // 129
	'useFabricEligibilityMigrationQuery', // 130
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 131
	'useFeedTypeSelectorRefreshQuery', // 132
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 133
	'useGetCurrentStorageUsageQuery', // 134
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 135
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 136
	'useHomeWidgetStateQuery', // 137
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 138
	'useIsLoomEntryPointsEnabledQuery', // 139
	'useIsUserViewingSpaceAsAnonQuery', // 140
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 141
	'useLoomTenantProvisionStatusQuery', // 142
	'usePopularFeedWithTimeGranularityStorageQuery', // 143
	'usePreloadCommentButtonQuery', // 144
	'useReadTimeQuery', // 145
	'useRegisterAdminAnnouncementBannerQuery', // 146
	'useShareAndRestrictButtonDataQuery', // 147
	'useShortcutsSpaceNavigationQuery', // 148
	'useSpaceBaseQueryBaseQuery', // 149
	'useSpaceDetailQuery', // 150
	'useSpaceEnabledContentTypesQuery', // 151
	'useSpaceViewsDataSpaceRootQuery', // 152
	'useSpaceViewsOptionsPersistenceQuery', // 153
	'useSpacesDataAnonymousSpacesQuery', // 154
	'useSpacesDataMyVisitedSpacesQuery', // 155
	'useSpacesDataStarredSpacesQuery', // 156
	'useTitleContentPropertiesForEditorQuery', // 157
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 158
	'useTitleContentPropertiesForPublishedPageQuery', // 159
	'useUserByLicensedProductsQuery', // 160
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b77fa7ff3ffbf65ffecffffffd29f7bfff301', /* 131 fast, 15 slow, 7 excl */
	'prod-apne2': '35ff7bf7fa5ff3ffbf6dff6cffff9fdadf7bfff300', /* 129 fast, 16 slow, 46 excl */
	'prod-apse': 'bdff7bf7fb5ff7ffbf6dffecffffffdadf7bfff701', /* 138 fast, 12 slow, 42 excl */
	'prod-apse2': 'bdff7ff7fa5ff7ffbf75ffecffffffdadf7bffff01', /* 139 fast, 11 slow, 41 excl */
	'prod-apsouth': 'bdff7b77fa5ff3ffbf75ffecffffbfdadd7bfffb01', /* 133 fast, 12 slow, 11 excl */
	'prod-cacentral': '3dff7b77fb7ff7ffbf75ffecffffbfdadf7ffffb01', /* 137 fast, 7 slow, 10 excl */
	'prod-east': '9dff7ff7fb7ff7ffbf7dffeeffffffdadf7fffff01', /* 143 fast, 10 slow, 52 excl */
	'prod-eucentral': '9fff7ff7fa57f7ffbf6dffeeffffffd2df7bfff701', /* 137 fast, 16 slow, 95 excl */
	'prod-eucentral2': 'b5df7b37f85ef6fd3f65f76cffff2fd0df7bfff300', /* 118 fast, 21 slow, 12 excl */
	'prod-euwest': 'bfff7ff7fb7ff7ffbf7dffeeffffffd2df7fffff01', /* 144 fast, 9 slow, 99 excl */
	'prod-euwest2': 'bdff7bf7fb7ef7ffbf75ffecffffbfdadf7ffffb01', /* 138 fast, 8 slow, 8 excl */
	'prod-west2': '9dff7ff7fe7ff7ffbf7dffeeffffffdadf7fffff01', /* 143 fast, 9 slow, 102 excl */
	'stg-east': '76f7fb77f87ffdddff57fffd3efebfdedf7fffff01', /* 134 fast, 8 slow, 61 excl */
};
